import { useState } from "react";
import { StyleSheet, Text, View } from "react-native";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import ZigzagView from "react-native-zigzag-view";
import IconButton from "../../../components/ButtonIcon";
import { dateFormatBR, numberToMoney, right } from "../../../helpers/util";
import * as Colors from "../../../styles/colors";
import * as Fonts from "../../../styles/typography";
import StatusPaymentIcon from "./StatusPaymentIcon";
import ReceiptEmail from "../../../components/ReceiptEmail";

export default function Item({ item }) {
  const [moreInfo, setMoreInfo] = useState(false);

  const [visible, setVisible] = useState(false);
  const datePayment = dateFormatBR(item.paymentHistoric.paH_DT_PAYMENT);
  const statusCodePayment = right(
    item.paymentHistoric.paH_NM_STATUS,
    4
  ).replace(/\D/g, "");

  return (
    <View style={styles.viewPrincipal}>
      <View
        style={{
          flexDirection: "row",
          marginTop: 4,
          alignItems: "center",
          backgroundColor: Colors.SECONDARY,
          width: "100%",
          justifyContent: "center",
          borderTopStartRadius: 8,
          borderTopEndRadius: 8,
          padding: 4,
        }}
      >
        <Icon name="map-marker-outline" size={24} color={Colors.WHITE} />
        <Text
          style={[
            styles.textSubItem,
            { fontSize: Fonts.FONT_SIZE_16, color: Colors.WHITE },
          ]}
        >
          {item.paymentHistoric.unity.address}
        </Text>
      </View>
      <View style={styles.viewItem}>
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <StatusPaymentIcon
            statusCode={statusCodePayment}
            message={
              item.paymentHistoric.paH_NM_STATUS +
              "\nNSU: " +
              item.paymentHistoric.paH_NM_NIT.trim()
            }
          />
          <View>
            <View style={styles.viewSubItem}>
              <Icon name="calendar" size={24} />
              <Text style={styles.textSubItem}>{datePayment}</Text>
            </View>
            <View style={styles.viewSubItem}>
              <Icon name="car" size={24} />
              <Text style={styles.textSubItem}>{item.paY_NM_PLATE}</Text>
            </View>
          </View>
          <View>
            <View style={styles.viewSubItem}>
              <Icon name="credit-card" size={24} />
              <Text style={styles.textSubItem}>
                {"Final " + item.paY_NM_LAST_CARD_DIGITS}
              </Text>
            </View>
            <View style={styles.viewSubItem}>
              <Icon name="currency-usd" size={24} />
              <Text style={styles.textSubItem}>
                {"R$ " + numberToMoney(item.paY_NR_VALUE_CENTS)}
              </Text>
            </View>
          </View>
          <Icon
            name={moreInfo ? "chevron-down" : "chevron-right"}
            size={32}
            onPress={() => setMoreInfo(!moreInfo)}
          />
        </View>
      </View>

      {moreInfo ? (
        <View style={styles.viewBottom}>
          <ZigzagView
            style={styles.textTicketView}
            backgroundColor={Colors.WHITE}
            surfaceColor={Colors.TICKET}
          >
            <View style={{ alignItems: "center" }}>
              {item.paymentHistoric.paH_NM_CUSTOMER_RECEIPT ? (
                item.paymentHistoric.paH_NM_CUSTOMER_RECEIPT
                  .split("\n")
                  .map((line, index) => {
                    return (
                      <Text
                        key={index}
                        style={{
                          fontSize: Fonts.FONT_SIZE_16,
                          fontWeight: "700",
                        }}
                      >
                        {line.trim()}
                      </Text>
                    );
                  })
              ) : (
                <Text>{"Não encontrado"}</Text>
              )}
            </View>
          </ZigzagView>
          <View style={{ padding: 8 }}>
            {statusCodePayment == "0" ? (
              <IconButton
                textoBotao={"Email"}
                iconName={"email"}
                onPress={() => {
                  setVisible(true);
                }}
                estilo={{ backgroundColor: Colors.INFO, width: "100%" }}
              />
            ) : null}
            <ReceiptEmail
              modalVisible={visible}
              setModalVisible={setVisible}
              receiptId={item.paymentHistoric.paH_CD_HISTORIC}
            />
          </View>
        </View>
      ) : null}
    </View>
  );
}

const styles = StyleSheet.create({
  viewItem: {
    borderBottomStartRadius: 8,
    borderBottomEndRadius: 8,
    // flexDirection: "row",
    alignItems: "center",
    marginBottom: 8,
    padding: 4,
    width: "100%",
    justifyContent: "space-between",
  },
  viewPrincipal: {
    width: "100%",
    backgroundColor: Colors.SNOW,
    shadowColor: Colors.GRAY_DARK,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
    marginBottom: 8,
  },
  viewSubItem: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    margin: 4,
  },
  receipt: {
    fontSize: Fonts.FONT_SIZE_18,
  },
  receiptView: {
    padding: 8,
    marginVertical: 16,
    flex: 1,
    flexGrow: 1,
    marginHorizontal: 8,
    opacity: 0.9,
  },
  textSubItem: {
    marginLeft: 4,
  },
  textTicketView: {
    margin: 8,
    textAlign: "center",
    justifyContent: "center",
  },
  viewBottom: {
    borderWidth: 1,
    borderTopWidth: 0,
    borderBottomEndRadius: 8,
    borderBottomStartRadius: 8,
    marginHorizontal: 8,
  },
});
